import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";

import Swal from "sweetalert2";

import {
  Invite,
  User,
  InviteListConfig,
  Discussion,
  Community,
} from "../../../../../../../shared/models";
import {
  CommunityService,
  DiscussionService,
  InviteService,
  UserService,
} from "../../../../../../services";

@Component({
  selector: "invite-card-preview",
  templateUrl: "./invite-card-preview.component.html",
  styleUrls: [
    "./invite-card-preview.component.scss",
    "../../../../../../../../assets/icon/icofont/css/icofont.scss",
    "../../../../../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
  ],
})
export class InviteCardPreviewComponent {
  private defaultUserImg: string =
    "../../../../../../../../assets/images/uMuzi/african-mask.png";

  @Input() config: InviteListConfig;
  @Input() currentUser: User;
  @Input() invite: Invite;
  @Output() updateInvites = new EventEmitter<any>();
  @Output() updateLoading = new EventEmitter<any>();

  constructor(
    private router: Router,
    private inviteService: InviteService,
    private userService: UserService,
    private discussionService: DiscussionService,
    private communityService: CommunityService
  ) {}

  ngOnInit() {}

  public makeLoadingTo(status) {
    this.updateLoading.emit(status);
  }

  public openInviteAcceptConfirmation(invite: Invite) {
    Swal.fire({
      title: "Invite accept?",
      text: "Sure you want to accept this invite",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, accept!",
    }).then((result) => {
      if (result.value) {
        this.acceptInvite(invite);
      }
    });
  }

  public fireAcceptSuccessAlert() {
    Swal.fire("Published", "Invite accepted.", "success");
  }

  public fireRejectSuccessAlert() {
    Swal.fire("Published", "Invite rejected.", "success");
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your submission.", "warning");

    window.scrollTo(0, 0);

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }

  public acceptInvite(invite: Invite) {
    this.makeLoadingTo(true);

    this.userService.isAuthenticated.subscribe((authenticated) => {
      // Not authenticated? Push to login screen
      if (!authenticated) {
        this.router.navigateByUrl("/login");
        return;
      }

      // Accept this invite if it was not accepted already
      if (invite.status !== "accepted") {
        if (invite.targetModel === "Discussion") {
          return this.discussionService
            .findOne(invite.target.slug)
            .subscribe((discussion: Discussion) => {
              invite.target = discussion;
              this.accept(invite);
            });
        }

        if (invite.targetModel === "Community") {
          return this.communityService
            .findOne(invite.target.name)
            .subscribe((community: Community) => {
              invite.target = community;
              this.accept(invite);
            });
        }
      }
    });
  }

  public rejectInvite(invite: Invite) {
    this.makeLoadingTo(true);

    this.userService.isAuthenticated.subscribe((authenticated) => {
      // Not authenticated? Push to login screen
      if (!authenticated) {
        this.router.navigateByUrl("/login");
        return;
      }

      // Accept this invite if it was not rejected already
      if (invite.status !== "rejected") {
        if (invite.targetModel === "Discussion") {
          return this.discussionService
            .findOne(invite.target.slug)
            .subscribe((discussion: Discussion) => {
              invite.target = discussion;
              this.reject(invite);
            });
        }

        if (invite.targetModel === "Community") {
          return this.communityService
            .findOne(invite.target.name)
            .subscribe((community: Community) => {
              invite.target = community;
              this.reject(invite);
            });
        }
      }
    });
  }

  public accept(invite: Invite) {
    this.inviteService.accept(invite).subscribe(
      (data) => {
        this.makeLoadingTo(false);

        this.updateInvites.emit({
          inviteId: invite.id,
          status: "accepted",
        });

        this.fireAcceptSuccessAlert();

        if (invite.targetModel === "Discussion") {
          this.router.navigateByUrl("/discussion/" + invite.target.slug);
        }
        if (invite.targetModel === "Community") {
          this.router.navigateByUrl("/community/" + invite.target.name);
        }
      },
      (err) => {
        this.makeLoadingTo(false);
        this.fireErrorAlert();
      }
    );
  }

  public reject(invite: Invite) {
    this.inviteService.reject(invite).subscribe(
      (data) => {
        this.makeLoadingTo(false);

        this.updateInvites.emit({
          inviteId: invite.id,
          status: "rejected",
        });

        this.fireRejectSuccessAlert();
      },
      (err) => {
        this.makeLoadingTo(false);
        this.fireErrorAlert();
      }
    );
  }

  public openInviteRejectConfirmation(invite: Invite) {
    Swal.fire({
      title: "Invite reject?",
      text: "Sure you want to reject this invite",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, reject!",
    }).then((result) => {
      if (result.value) {
        this.rejectInvite(invite);
      }
    });
  }
}
